import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css'
import './assets/css/index.less'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import { globalRegister } from './global'

// import { createPinia } from 'pinia'
import './permission'
import store from '@/store'

const app = createApp(App)
// const pinia = createPinia()
app.use(ElementPlus)
app.use(globalRegister)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

import VueAMap, {initAMapApiLoader} from '@vuemap/vue-amap';
// import VueAMapLoca from '@vuemap/vue-amap-loca';
// import VueAMapExtra from '@vuemap/vue-amap-extra';
import '@vuemap/vue-amap/dist/style.css'
initAMapApiLoader({
  // key: '62fb6f22ca8748405c582db83a63817d',
  // securityJsCode: 'e281be3f870098c8ea1a7d46eb9c6913', // 新版key需要配合安全密钥使用
  key:'74069daa28e9fd4da3038ee356cb1b57',
  securityJsCode:'89a73ab234995658a5c1b5f547e83849'
  //Loca:{
  //  version: '2.0.0'
  //} // 如果需要使用loca组件库，需要加载Loca
})

app.use(VueAMap)
// app.use(pinia)
app.use(store)
app.use(router)
// app.mount('#app')

// 手机端调试
import Vconsole from 'vconsole'
if (process.env.VUE_APP_ENV !== 'production') {
  new Vconsole()
}
router.isReady().then(() => {
  app.mount('#app')
})
